<template>
  <v-container id="city-get">
    <city-header :payload="payload" @realod="loadFirst"> </city-header>

    <v-row class="aqui">
      <v-col class="mt-4">
        <v-row>
          <v-col cols="6">
            <v-card class="agendaRegistro">
              Agendas
              <div>
                {{ municipioInfo.atividadesAgendadas }}
              </div>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card class="agendaRegistro">
              Registros
              <div>
                {{ municipioInfo.documentosAtividades }}
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-card>
              <v-data-table
                :headers="headerEixos"
                :items="municipioInfo.eixoSubEixo"
                class="elevation-1 govTable"
                hide-default-footer
                disable-pagination
              >
                <template slot="no-data"> Nenhum dado retornado </template>
              </v-data-table>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card>
              <v-data-table
                :headers="headerInstituicao"
                :items="municipioInfo.instituicaoCategoria"
                class="elevation-1 govTable"
                hide-default-footer
                disable-pagination
              >
                <template slot="no-data"> Nenhum dado retornado </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col md="3" sm="3" lg="3">
        <v-row
          v-if="
            isFullAdmin ||
            (config.visualizaRelatorioFinal &&
              groupsConfig.visualizaRelatorioFinal)
          "
        >
          <v-col>
            <v-btn
              outlined
              color="primary"
              class="ml-3"
              @click="verificarRelatorioFinal()"
            >
              Relatório Final
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              outlined
              color="primary"
              class="ml-3"
              v-if="
                payload.diagnostico === false &&
                (isFullAdmin ||
                  (config.realizarDiagnostico &&
                    groupsConfig.realizarDiagnostico))
              "
              @click="openDiagnostic()"
            >
              <template> RESPONDER DIAGNÓSTICO </template>
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <app-modal-edit-city
              v-if="
                isFullAdmin ||
                (config.editarMunicipio && groupsConfig.editarMunicipio)
              "
              @save="loadCity()"
              :payload="payload"
              :edit="true"
            ></app-modal-edit-city>
          </v-col>
        </v-row>
        <v-row v-if="config.resumoMunicipio && groupsConfig.resumoMunicipio">
          <v-col>
            <v-btn
              outlined
              color="primary"
              class="ml-3"
              @click="$router.push(`/cidade/${municipioId}/resumo-municipio`)"
            >
              <template> ATORES DO PROJETO</template>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="config.relatorioMensal && groupsConfig.relatorioMensal">
          <v-col>
            <app-modal-report :municipioId="municipioId"> </app-modal-report>
          </v-col>
        </v-row>
        <v-row
          v-if="
            config.dadosCadastraisMunicipio &&
            groupsConfig.dadosCadastraisMunicipio
          "
        >
          <v-col>
            <modal-dados-cadastrais
              :dadosPayload="dadosCadastrais"
              @onLoad="loadDadosCadastrais"
            >
              <template v-slot:title> Dados Cadastrais </template>
            </modal-dados-cadastrais>
          </v-col>
        </v-row>
      </v-col>
      <modal-link-oculto-relatorio-final
        :municipio="payload"
        :dialog="abrirModalRelFinal"
        @relFimCriado="gerarRelatorioFinal()"
        @atualizarRelatorio="loadCity()"
      ></modal-link-oculto-relatorio-final>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import AppModalEditCity from "@/modules/city/components/ModalEdit";
import CityHeader from "@/modules/city/components/Header";
import { cityAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";
import AppModalReport from "@/modules/report/components/ModalReport";
import { diagnosticAPI } from "@/modules/diagnostic/components/DiagnosticAPI.js";
import { reportAPI } from "@/modules/report/API/ReportAPI";
import ModalLinkOcultoRelatorioFinal from "@/modules/city/components/ModalLinkOcultoRelatorioFinal.vue";
import { seloDiagnosticoRespostaAPI } from "@/modules/diagnosticoSelo/API/seloDiagnosticoRespostaAPI";
import ModalDadosCadastrais from "@/modules/city/components/propostas/modalDadosCadastrais.vue";
import { municipioPropostaDadosApi } from "@/apis";
export default {
  components: {
    AppModalEditCity,
    CityHeader,
    AppModalReport,
    ModalLinkOcultoRelatorioFinal,
    ModalDadosCadastrais,
  },
  data() {
    return {
      removeLoading: false,
      abrirModalRelFinal: false,
      municipioId: this.$route.params.id,
      user: JSON.parse(localStorage.getItem("user")),
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      payload: {
        acompanhamentos: [],
        temas: [],
      },
      municipioInfo: {},
      dadosCadastrais: {},
      editReport: false,
      estado: this.$store.state.uf,
      headerEixos: [
        { text: "Eixo", value: "eixo", sortable: false },
        { text: "Subeixo", value: "subeixo", sortable: false },
      ],
      headerInstituicao: [
        { text: "Instituição", value: "instituicao", sortable: false },
        { text: "Categoria", value: "categoria", sortable: false },
      ],
    };
  },
  watch: {
    loading(val) {
      if (this.removeLoadingFirst) this.setLoading(val);
      else this.setLoading(true);
    },
  },
  methods: {
    ...mapActions(["setLoading", "setCityName", "setCityId"]),
    verificarRelatorioFinal() {
      this.gerarRelatorioFinal();
    },
    downloadPdf() {
      this.setLoading(true);
      seloDiagnosticoRespostaAPI
        .downloadPdf(this.municipioId)
        .then((resp) => {
          let blob = new Blob([resp.data], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `Diagnostico - ${this.payload.nome} - ${
            this.payload.uf
          } - ${moment().format("DD_MM_YYYY_HH_mm")}.pdf`;
          link.click();
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter PDF");
        });
    },
    async loadCity() {
      this.abrirModalRelFinal = false;
      this.setLoading(true);

      try {
        var city = await cityAPI.get(this.$route.params.id);
        var infos = await cityAPI.getMunicipioGov(this.$route.params.id);

        this.payload = city.data;
        this.municipioInfo = infos.data;
        this.loadDadosCadastrais();
        this.municipioInfo.atividadesAgendadas = Array.isArray(
          this.municipioInfo.atividadesAgendadas
        )
          ? this.municipioInfo.atividadesAgendadas[0].atividadesAgendadas
          : 0;

        this.municipioInfo.documentosAtividades = Array.isArray(
          this.municipioInfo.documentosAtividades
        )
          ? this.municipioInfo.documentosAtividades[0]
              .registrosDocumentosAtividades
          : 0;

        this.setCityName(this.payload.nome);
        this.setCityId(this.payload.municipioId);
        this.$forceUpdate();

        var temasPermissoes = this.payload.temas;

        if (!this.user.grupo.verTodosEixos) {
          temasPermissoes = temasPermissoes.filter((item) =>
            this.user.permissoes.some(
              (per) =>
                per.eixoId === item.tema.eixoId &&
                per.municipioId === item.municipioId
            )
          );

          this.payload.medalhas = this.payload.medalhas.filter((item) =>
            this.user.permissoes.some(
              (per) =>
                per.eixoId === item.medalha.temaId &&
                per.municipioId === item.municipioId
            )
          );
        }

        this.setLoading(false);
        this.removeLoadingFirst = true;
      } catch (error) {
        this.removeLoadingFirst = true;
        this.setLoading(false);
        this.$notification.error("Erro ao obter projeto");
      }
    },
    loadDadosCadastrais() {
      municipioPropostaDadosApi
        .getDadosPorMunicipioId(this.municipioId)
        .then((resp) => {
          this.dadosCadastrais =
            (resp.data && resp.data.length && resp.data[0]) || {};
        })
        .catch(() => {
          this.$notification.error("Erro ao obter os Dados cadastrais");
        });
    },
    gerarRelatorioFinal() {
      this.abrirModalRelFinal = false;
      this.setLoading(true);
      reportAPI
        .downloadRelatorioFinal(this.municipioId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `Relatorio Final - ${this.payload.nome}.pdf`;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatorio final");
        });
    },
    updateReport() {
      this.setLoading(true);
      cityAPI
        .update(this.payload)
        .then((resp) => {
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao atualizar relatório");
        });
    },
    openDiagnostic() {
      this.setLoading(true);
      diagnosticAPI
        .createDiagnostic(this.acompanhamento)
        .then((resp) => {
          this.setLoading(false);
          this.$router.push(
            "/diagnostico/" + this.acompanhamento.municipioId + "/tema"
          );
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao criar diagnóstico");
        });
    },
    loadFirst() {
      this.setLoading(true);
      this.loadCity();
      document.getElementsByClassName("v-main__wrap")[0].style.background =
        "none";
    },
  },
  mounted() {
    this.loadFirst();
  },

  computed: {
    ...mapGetters(["loading", "isFullAdmin"]),
  },
};
</script>
<style lang="scss">
.govTable {
  th {
    background-color: var(--corPrimaria);
    span {
      color: #fff;
      font-size: 14px;
    }
  }
  tbody {
    tr:nth-child(even) {
      background-color: #9079a842;
    }
  }
}
</style>

<style lang="scss" scoped>
.agendaRegistro {
  padding: 10px;
  background-color: var(--corPrimaria);
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  div {
    font-size: 24px;
  }
}
.aqui {
  height: 69%;
}
.tituloStatus {
  font-size: 40px;
  font-weight: bold;
}
.diagnosticoSelo {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  /* padding: 3rem; */
  height: 100%;
  row-gap: 3rem;
}
</style>

<style lang="scss">
.container {
  height: 100%;
}
.htmlContainer {
  padding: 0 2rem !important;
  text-align: justify !important;
}
.estruturas {
  text-align: left !important;

  width: fit-content;
  row-gap: 10px;
  display: flex;
  flex-direction: column;
}

.tamanho {
  max-width: 1300px;
}

.atencao {
  text-align: center;
}
</style>
